// ESM-Huelle um lib/scripts/pos/CLS_CBarcodeReader.js (Phase 4, Welle 4a).
// Prototype-Stil bleibt vorerst.
function CBarcodeReader() {
    this.inputChars = "";
    this.newChar = null;
    this.startTimeStamp = 0;
    this.endTimeStamp = 0;
}

CBarcodeReader.prototype.readInput = function(event) {
    var d = new Date();
    if (this.inputChars == "")
        this.startTimeStamp = (d / 1000).toFixed(0);

    //this.newChar = String.fromCharCode (event.charCode);
    this.newChar = event.char;

    if (event.charCode == 0) {
        var completedInput = this.inputChars;
        this.inputChars = "";

        this.endTimeStamp = (d / 1000).toFixed(0);
        var differenceTime = this.endTimeStamp - this.startTimeStamp;

        if (differenceTime > 1) {} else
            this.processInput(completedInput, null, "screen");
    } else {
        this.inputChars += this.newChar;
        //POS.events.lastFocusedComponent.gotKey(this.inputChars);
    }
}

CBarcodeReader.prototype.processInput = function(inputString, mainBon, from) {
    if (!mainBon)
        var mainBon = POS.sessions.getSessionComponent();

    if (POS.blockedStatus || (POS.bankomatActive && from == "screen"))
        return;


    var regExpPersonalCard = new RegExp("^[0-9]{4,6}$", "g");
    //var regExpPersonalCard        = new RegExp("^333[0-9]{5}$", "g");
    var regExpWholesaleCustomerCard = new RegExp("^222[0-9]{10}$", "g");
    var regExpCustomerCard = new RegExp("^111[0-9]{10}$", "g");
    var regExpBarcode = new RegExp("^99[0-9]{10}$", "g");
    var regExpPrepaidCard = new RegExp("^444[0-9]{10}$", "g");
    var regExpPaydown = new RegExp("^555[0-9]{11,}$", "g");
    var regExpButton = new RegExp("^777[0-9]{9}$", "g");
    var regExpRebate = new RegExp("^666[0-9]{10}$", "g");
    var regExpEAN = new RegExp("^[0-9]{1,}$", "g");

    inputString = new String(inputString);
    if (inputString == "") {
        log.add(4, "Info", "Returned from CBarcodeReader.processInput() - empty string");
        return;
    }

    var type = 0;

    if (inputString.indexOf("*") == 0) {
        inputString = inputString.replace("*", "");
        inputString = inputString.replace("*", "");
    }
    if (inputString.match(regExpPersonalCard) != null)
        type = "idPers";
    else if (inputString.match(regExpCustomerCard) != null)
        type = "idCust";
    else if (inputString.match(regExpWholesaleCustomerCard) != null)
        type = "idWholeCust";
    else if (inputString.match(regExpBarcode) != null)
        type = "Barcode";
    else if (inputString.match(regExpPrepaidCard) != null)
        type = "PpCard";
    else if (inputString.match(regExpPaydown) != null)
        type = "Paydown";
    else if (inputString.match(regExpButton) != null)
        type = "Button";
    else if (inputString.match(regExpRebate) != null)
        type = "Rebate";
    else if (inputString.match(regExpEAN) != null)
        type = "EAN";

    try {
        this.execute(inputString, type, mainBon, from);
    } catch (e) {
        log.add(2, "Error", "Could not execute barcode event:", e);
    }
}

CBarcodeReader.prototype.execute = function(inputString, type, mainBon, from) {
    log.add(4, "Info", "Barcode read '" + inputString + "' type '" + type + "' from " + from, "");

    if (!mainBon)
        var mainBon = POS.sessions.getSessionComponent();

    if (typeof mainBon.UID != "undefined" && POS.message.isMessageActive(mainBon.UID) && type != "idPers") {
        log.add(4, "Info", "Returned from CBarcodeReader.execute() - returnId = 0");
        return;
    }

    if (from == "funklogin" && type != "idPers") {
        log.add(4, "Info", "Returned from CBarcodeReader.execute() - returnId = 1");
        return;
    }

    if (type != "idPers" && ((typeof mainBon.cmpBalance != "undefined" && mainBon.cmpBalance.transmitted) ||
            (typeof mainBon.cmpBAR != "undefined" && mainBon.cmpBAR.paymentType) ||
            (typeof mainBon.BonManager.cmpPPU != "undefined" && mainBon.BonManager.cmpPPU.transmitted) ||
            (typeof mainBon.BonManager.cmpBCC != "undefined" && mainBon.BonManager.cmpBCC.transmitted))) {
        log.add(4, "Info", "Returned from CBarcodeReader.execute() - returnId = 2");
        return;
    }
    // Waehrend der Bon abgeschlossen wird (payCallback bis reset: Signatur, Druck)
    // landete ein Scan auf dem schon signierten Bon und auf dem Beleg - Kasse 932,
    // 25.10.2026. Die Sperre ueber cmpBAR.paymentType ist da schon aufgehoben.
    if (type != "idPers" && mainBon.BonManager && mainBon.BonManager.isProcessingPayment) {
        log.add(2, "Warning", "Scan '" + inputString + "' verworfen - Bon " + mainBon.BonManager.currentBonId + " wird gerade abgeschlossen");
        return;
    }
    try {
        // Die urspruengliche Oder-Bedingung hatte einen ersten Teil, der
        // barcodeRequested verlangte (Funkscanner, entfallen am 26.8.2026) -
        // ohne Scanner war er immer falsch. Der ZWEITE Teil ist echt und
        // bleibt: bei offener Kassenlade wird nicht boniert.
        if (mainBon.UID == POS.sessions.currentSession && POS.Cashbox.isDrawerOpen() && !POS.Cashbox.canBeOpen) {
            log.add(4, "Info", "Returned from CBarcodeReader.execute() - returnId = 3");
            // Frueher stumm verworfen - am Bildschirm sah das wie eine kaputte
            // Personalkarte aus (Testkasse 21.10.2026). Sperre bleibt, nur mit Hinweis.
            if (!POS.message.isMessageActive(mainBon.UID))
                POS.message.show("Bitte zuerst die Kassenlade schließen.", "warning", "OK");
            return;
        }
    } catch (e) {
        log.add(2, "Error", "Error in BarcodeReader:", e);
    }

    switch (type) {
        case "idPers":
            var userId = inputString;
            userId = userId.replace("L", "");

            if (typeof mainBon.cmpBalance != "undefined" && mainBon.cmpBalance.transmitted &&
                mainBon.cmpBalance.mode == "transfer") {
                mainBon.cmpBalance.getPersonalCard(userId);
                return;
            }

            if (POS.Screensaver && POS.Screensaver.transmitted) {
                POS.events.applyTS = true;
                var parameters = new Array(POS.Screensaver.id);
                POS.Screensaver.close(null, parameters);
            }

            if (POS.sessions.currentSession != 0 &&
                mainBon.BonManager.displayMode == "purchase") {
                mainBon.BonManager.displayTarget.purchaserId = userId;
                mainBon.BonManager.displayTarget.getPersonalCard();
            } else {
                if (typeof POS.message.sessions[mainBon.UID] != "undefined" &&
                    POS.message.sessions[mainBon.UID].active && from == "screen") {
                    POS.message.holdMessage = true;
                    POS.message.hide();
                }

                POS.sessions.loadSessionFromBarcode(userId);
            }
            break;
        case "idCust":
            // Der zweite Teil der Bedingung (Funkscanner) ist am 26.8.2026 entfallen -
            // ohne Scanner war barcodeRequested immer falsch.
            if (POS.sessions.currentSession != 0) {
                var customerId = inputString;
                mainBon.EANManager.getCustomerFromBarcode(customerId, 'cust');
            }
            break;
        case "idWholeCust":
            if (POS.sessions.currentSession != 0) {
                var customerId = inputString;
                mainBon.EANManager.getCustomerFromBarcode(customerId, 'wholecust');
            }
            break;
        case "EAN":
            if (POS.sessions.currentSession != 0) {
                var EANCode = inputString;
                mainBon.EANManager.getProductFromEANCode(EANCode);
            }
            break;
        case "Barcode":
            if (POS.sessions.currentSession != 0) {
                var Barcode = inputString;
                mainBon.EANManager.getProductFromEANCode(Barcode);
            }
            break;
        case "Paydown":
            var bonId = inputString.substr(13);
            mainBon.BonManager.recoverPaydownBon(bonId);
            break;
        case "Button":
            if (POS.sessions.currentSession != 0) {
                var Barcode = inputString;
                mainBon.EANManager.getButtonFromBarcode(Barcode);
            }
            break;
        case "Rebate":
            if (POS.sessions.currentSession != 0) {
                var Barcode = inputString;
                mainBon.EANManager.getRebateFromBarcode(Barcode);
            }
            break;
        case "PpCard":
            mainBon.prepaidCardPayment(inputString);
            break;
    }
}

export { CBarcodeReader };
